import React, { useState, useEffect } from 'react'
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { BACKEND_URI } from '../config'

import { Button, Checkbox } from '@mui/material'



// Renders errors or successfull transactions on the screen.
function Message({ content }) {
  return <p>{content}</p>
}

function CheckoutPage({
  FundstoAdd,
  setCartItems,
  useFunds,
  orderType,
  orderID,
  isPickup,
}) {
  const navigate = useNavigate()
  const [message, setMessage] = useState('')
  const [chargeAmount, setChargeAmount] = useState(0.0)
  const [payedAmount, setPayedAmount] = useState(0.0)

  useEffect(() => {
    const fetchChargeAmount = async () => {
      try{
        if (!FundstoAdd){
          const token = localStorage.getItem('token')

          const response = await fetch(
            `${BACKEND_URI}/api/getCartTotal`,
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
              // body: JSON.stringify({username: user.username}), // Wrap in `cartItems` key
            }
          )

          if (!response.ok) {
            throw new Error('Failed to fetch cart from database')
          }

          const data = await response.json()

          setChargeAmount(data.totalAmount)
        }
        else {
          setChargeAmount(FundstoAdd)
        }
      }
      catch(error){
        setMessage(`ERROR: ${error}`)
      }
    }

    fetchChargeAmount();
  })

  const handleCreateOrder = async () => {
    try{
        const token = localStorage.getItem('token')

        const response = await fetch(
          `${BACKEND_URI}/api/create-order`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({FundstoAdd, isPickup}), // Wrap in `cartItems` key
          }
        )

        if (!response.ok) {
          throw new Error('Failed to create order')
        }

        const data = await response.json()

        setCartItems([])

        navigate('/fireworks/assortments')

        toast.success("Order has been created. Wait for admin approval")
    }
    catch(error){
      setMessage(`ERROR: ${error}`)
    }
  }

  return (
    <div style={styles.container}>
      <p> We only take payments through zelle/venmo/cash </p>
      <p> Pay amount ${chargeAmount} (or at least 20% now and the rest later) to this phone number: (832)814-6238 </p>
      <p> Make sure to add a message in your payment saying it is for a fireworks purchase and if delivery your address.</p>

      <div>Once you have payed, press the button below</div>
      <Button
      onClick={handleCreateOrder}
      variant='contained'
      // color="primary"
      style={{ marginBottom: '10px', marginTop: '10px', backgroundColor: '#51a4ac' }}
      >Create Order
      </Button>
      <p>{message}</p>
    </div>
  )
}

export default CheckoutPage

// Add your styles here
const styles = {
  container: {
    display: "flex",
    flexDirection: "column", // Stack items vertically
    justifyContent: "center", // Center vertically
    alignItems: "center", // Center horizontally
    // height: "100vh", // Full viewport height to center content
    textAlign: "center", // Center text inside <p> elements
    padding: "1rem",
  },
}
